<template>
  <v-app
      id="sprint-symfony-webapp"
      class="full-sidebar"
  >
    <router-view :key="$route.fullPath" />
    <v-snackbar-queue
        v-model="notifications.queue">
    </v-snackbar-queue>

  </v-app>
</template>

<script setup lang="ts">

import {useToastStore} from "@common/store/feature/toast/toast";

const notifications = useToastStore();


</script>
